import React, {
  Fragment,
  useContext,
  useRef,
  useState,
  useEffect,
} from "react";
import Grid from "@mui/material/Grid";
import ButtonMui from "@mui/material/Button";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import SearchIcon from "@mui/icons-material/Search";
import SyncIcon from "@mui/icons-material/Sync";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import Menu from "./Menu";
import clienteAxios from "../../config/axios";
import { AlertContext } from "../../context/AlertContext";
import { AuthContext } from "../../context/AuthContext";
import { ConfiguracionContext } from "../../context/ConfiguracionContext";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import Spinner from "./Spinner";
import { saveAs } from "file-saver";
import { Dropdown } from "primereact/dropdown";
import { ProgressBar } from "primereact/progressbar";
import TextField from "@mui/material/TextField";

import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../../assets/css/DataTableDemo.css";

export default function RendicionesBancos() {
  const toast = useRef(null);
  const inputFileRef = useRef(null);
  let navigate = useNavigate();

  const { banco } = useParams();

  const [archivo, setArchivo] = useState(null);
  const [movimientos, setMovimientos] = useState([]);
  const [identificados, setIdentificados] = useState([]);
  const [pendientes, setPendientes] = useState([]);
  const [procesando, setProcesando] = useState(false);
  const [globalFilter, setGlobalFilter] = useState("");
  const [aceptados, setAceptados] = useState([]);
  const [rechazados, setRechazados] = useState([]);
  const [cuentaSeleccionada, setCuentaSeleccionada] = useState([]);
  const [progresoIdentificacion, setProgresoIdentificacion] = useState(0);
  const [fechaDesde, setFechaDesde] = useState("");
  const [fechaHasta, setFechaHasta] = useState("");

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const { statusAcceso, cuentas, obtenerAcceso, obtenerCuentas } =
    configuracionContext;

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({
        usuarioId: state.usuario.id,
        layout: "RendicionesEspeciales",
      });
    }
  }, [state.id]);

  useEffect(() => {
    obtenerCuentas();
  }, []);

  const exitClick = (e) => {
    navigate("/");
  };

  const normalizarNumero = (valor) => {
    if (valor === null || valor === undefined || valor === "") return 0;

    if (typeof valor === "number") return valor;

    return Number(
      valor
        .toString()
        .replace(/\./g, "")
        .replace(",", ".")
        .replace(/[^\d.-]/g, ""),
    );
  };

  const extraerDatosMovimiento = (concepto) => {
    const texto = concepto ? concepto.toString().toUpperCase().trim() : "";

    const cuit = texto.match(/\b(20|23|24|27|30|33|34)\d{9}\b/)?.[0] || null;

    const cbu = texto.match(/\b\d{22}\b/)?.[0] || null;

    let nombre = texto;

    nombre = nombre
      .replace(/^TRANSF\. INMEDIATA E\/CTAS\. DIST\. TITULAR/i, "")
      .replace(/^TRANSF\. INTERBANKING - DISTINTO TITULAR ORD\.:/i, "")
      .replace(/^CREDITO INMEDIATO \(DEBIN\) DIST TITULAR/i, "")
      .replace(/^TRANSFERENCIA POR PAGO DE HABERES CUENTA:\s*[\d-]*/i, "")
      .replace(/\b(20|23|24|27|30|33|34)\d{9}\b/g, "")
      .replace(/\b\d{22}\b/g, "")
      .replace(/CBU ORIGEN:/gi, "")
      .replace(/\bFAC\b/gi, "")
      .replace(/\bVAR\b/gi, "")
      .replace(/\bHON\b/gi, "")
      .replace(/\bCTA\b/gi, "")
      .replace(/\bORD\b/gi, "")
      .replace(/[.:,;\-]/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    return {
      cuit,
      cbu,
      nombre,
      conceptoOriginal: concepto,
    };
  };

  const buscarCampo = (row, posiblesNombres) => {
    const keys = Object.keys(row);

    for (const nombre of posiblesNombres) {
      const key = keys.find(
        (k) =>
          k.toString().trim().toUpperCase() ===
          nombre.toString().trim().toUpperCase(),
      );

      if (key) return row[key];
    }

    return null;
  };

  const convertirFechaFiltro = (valor) => {
    if (!valor) return null;

    if (valor instanceof Date) {
      return new Date(valor.getFullYear(), valor.getMonth(), valor.getDate());
    }

    const texto = valor.toString().trim();

    // dd/mm/yyyy
    if (texto.includes("/")) {
      const [dia, mes, anio] = texto.split("/");
      return new Date(Number(anio), Number(mes) - 1, Number(dia));
    }

    // yyyy-mm-dd
    if (texto.includes("-")) {
      const [anio, mes, dia] = texto.split("-");
      return new Date(Number(anio), Number(mes) - 1, Number(dia));
    }

    return null;
  };

  const leerArchivo = async () => {
    if (!archivo) {
      mensajeAlerta("Banco", "Debe seleccionar un archivo Excel.", "error");
      return;
    }

    if (!cuentaSeleccionada) {
      mensajeAlerta("Banco", "Debe seleccionar una cuenta.", "error");
      return;
    }

    if (!fechaDesde) {
      mensajeAlerta("Banco", "Debe ingresar fecha desde.", "error");
      return;
    }

    if (!fechaHasta) {
      mensajeAlerta("Banco", "Debe ingresar fecha hasta.", "error");
      return;
    }

    if (new Date(fechaHasta) < new Date(fechaDesde)) {
      mensajeAlerta(
        "Banco",
        "La fecha hasta no puede ser menor que la fecha desde.",
        "error",
      );
      return;
    }

    const convertirFechaFiltro = (valor) => {
      if (!valor) return null;

      if (valor instanceof Date) {
        return new Date(valor.getFullYear(), valor.getMonth(), valor.getDate());
      }

      const texto = valor.toString().trim();

      if (texto.includes("/")) {
        const [dia, mes, anio] = texto.split("/");
        return new Date(Number(anio), Number(mes) - 1, Number(dia));
      }

      if (texto.includes("-")) {
        const [anio, mes, dia] = texto.split("-");
        return new Date(Number(anio), Number(mes) - 1, Number(dia));
      }

      return null;
    };

    setProcesando(true);

    try {
      const xlsx = await import("xlsx");

      const data = await archivo.arrayBuffer();
      const workbook = xlsx.read(data, { type: "array" });

      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      const rows = xlsx.utils.sheet_to_json(sheet, {
        defval: "",
      });

      const desde = convertirFechaFiltro(fechaDesde);
      const hasta = convertirFechaFiltro(fechaHasta);

      desde.setHours(0, 0, 0, 0);
      hasta.setHours(23, 59, 59, 999);

      const soloCreditos = rows
        .map((row, index) => {
          let concepto = "";
          let credito = 0;
          let debito = 0;
          let fecha = "";

          if (banco === "supervielle") {
            const conceptoBase =
              buscarCampo(row, ["Concepto", "Descripción", "Descripcion"]) ||
              "";

            const detalle = buscarCampo(row, ["Detalle"]) || "";

            concepto = `${conceptoBase} ${detalle}`.trim();

            credito = normalizarNumero(
              buscarCampo(row, [
                "Crédito",
                "Credito",
                "Haber",
                "Importe Crédito",
                "Importe Credito",
              ]),
            );

            debito = normalizarNumero(
              buscarCampo(row, ["Débito", "Debito", "Debe", "Importe Débito"]),
            );

            fecha =
              buscarCampo(row, ["Fecha", "Fecha Valor", "Fecha Movimiento"]) ||
              "";
          } else if (banco === "credicoop") {
            concepto =
              buscarCampo(row, [
                "Concepto",
                "Descripción",
                "Descripcion",
                "Detalle",
                "Movimiento",
              ]) || "";

            credito = normalizarNumero(
              buscarCampo(row, [
                "Crédito",
                "Credito",
                "Haber",
                "Importe Crédito",
                "Importe Credito",
              ]),
            );

            debito = normalizarNumero(
              buscarCampo(row, ["Débito", "Debito", "Debe", "Importe Débito"]),
            );

            fecha =
              buscarCampo(row, ["Fecha", "Fecha Valor", "Fecha Movimiento"]) ||
              "";
          } else {
            return null;
          }

          const datos = extraerDatosMovimiento(concepto);

          return {
            id: index + 1,
            fecha,
            concepto,
            credito,
            debito,
            cuit: datos.cuit,
            cbu: datos.cbu,
            nombreExtraido: datos.nombre,
            socio: null,
            score: 0,
            estado: "Pendiente",
          };
        })
        .filter((x) => x && x.credito > 0)
        .filter((x) => {
          const fechaMov = convertirFechaFiltro(x.fecha);

          if (!fechaMov) return false;

          fechaMov.setHours(0, 0, 0, 0);

          return fechaMov >= desde && fechaMov <= hasta;
        });

      setMovimientos(soloCreditos);

      mensajeAlerta(
        "Banco",
        `Se encontraron ${soloCreditos.length} movimientos con crédito dentro del rango seleccionado.`,
        "success",
      );
    } catch (error) {
      console.log(error);
      mensajeAlerta("Banco", "Error leyendo el archivo.", "error");
    } finally {
      setProcesando(false);
    }
  };

  const procesarSocios = async () => {
    if (!identificados || identificados.length === 0) {
      mensajeAlerta("Banco", "No hay movimientos para procesar.", "error");
      return;
    }

    setProcesando(true);

    try {
      const respuesta = await clienteAxios.post(
        "/api/configuracion/procesarcreditosbancos",
        {
          identificados,
          pendientes,
          usuario: state.usuario,
          cuentaSeleccionada,
        },
      );

      let data1 = respuesta.data.aceptados;
      let data2 = respuesta.data.rechazados;

      setAceptados(data1);
      setRechazados(data2);

      let elem = document.getElementById("listadoBancos");
      if (elem) {
        setTimeout(() => {
          elem.click();
        }, 500);
      }

      mensajeAlerta("Banco", "Procesando identificados.", "success");
    } catch (error) {
      console.log(error);
      mensajeAlerta(
        "Banco",
        error.response?.data || "Error Procesando socios.",
        "error",
      );
    } finally {
      setProcesando(false);
    }
  };

  const identificarSocios = async () => {
    if (!cuentaSeleccionada) {
      mensajeAlerta("Banco", "Debe seleccionar una cuenta.", "error");
      return;
    }

    if (!fechaDesde || !fechaHasta) {
      mensajeAlerta(
        "Banco",
        "Debe ingresar fecha desde y fecha hasta.",
        "error",
      );
      return;
    }

    if (new Date(fechaHasta) < new Date(fechaDesde)) {
      mensajeAlerta(
        "Banco",
        "La fecha hasta no puede ser menor que la fecha desde.",
        "error",
      );
      return;
    }

    if (!movimientos || movimientos.length === 0) {
      mensajeAlerta("Banco", "No hay movimientos para procesar.", "error");
      return;
    }

    setProcesando(true);
    setProgresoIdentificacion(10);

    let intervalo = setInterval(() => {
      setProgresoIdentificacion((prev) => {
        if (prev >= 90) return prev;
        return prev + 5;
      });
    }, 800);

    try {
      const respuesta = await clienteAxios.post(
        "/api/configuracion/identificarcreditosbancos",
        {
          movimientos,
          cuentaSeleccionada,
          fechaDesde,
          fechaHasta,
        },
      );

      clearInterval(intervalo);
      setProgresoIdentificacion(100);

      const resultado = respuesta.data.resultado || [];
      const identificados = respuesta.data.identificados || [];
      const pendientes = respuesta.data.pendientes || [];

      setMovimientos([...identificados, ...pendientes]);

      setIdentificados(identificados);
      setPendientes(pendientes);

      mensajeAlerta("Banco", "Movimientos identificados.", "success");
    } catch (error) {
      clearInterval(intervalo);
      console.log(error);
      mensajeAlerta(
        "Banco",
        error.response?.data || "Error identificando socios.",
        "error",
      );
    } finally {
      setTimeout(() => {
        setProgresoIdentificacion(0);
        setProcesando(false);
      }, 800);
    }
  };

  const estadoBody = (rowData) => {
    if (rowData.estado === "Identificado") {
      return <Tag severity="success" value="Identificado" />;
    }
    if (rowData.estado === "Mas 1 Afiliado") {
      return <Tag severity="warning" value="Mas 1 Afiliado" />;
    }
    if (rowData.estado === "Sin Comprobante") {
      return <Tag severity="info" value="Sin Comprobante" />;
    }
    if (rowData.estado === "Mas 1 Comprobante") {
      return <Tag severity="info" value="Mas 1 Comprobante" />;
    }
    if (rowData.estado === "Pagos Aplicados") {
      return <Tag severity="info" value="Pagos Aplicados" />;
    }
    if (rowData.estado === "Pago Procesado") {
      return <Tag severity="info" value="Pago Procesado" />;
    }
    if (rowData.estado === "Otra Empresa") {
      return <Tag severity="info" value="Otra Empresa" />;
    }
    if (rowData.estado === "Comprobante Posterior") {
      return <Tag severity="info" value="Comprobante Posterior" />;
    }
    if (rowData.estado === "Credito Ya Procesado") {
      return <Tag severity="info" value="Credito Ya Procesado" />;
    }
    return <Tag severity="danger" value="Sin Identificar" />;
  };

  const socioBody = (rowData) => {
    if (!rowData.socio) return "";

    return `${rowData.socio.id_titular || ""} - ${
      rowData.socio.nombre_razonsocial ||
      rowData.socio.razon_social ||
      rowData.socio.nombre ||
      ""
    }`;
  };

  const importeBody = (rowData) => {
    return Number(rowData.credito || 0).toLocaleString("es-AR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const header = (
    <div className="table-header">
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          value={globalFilter}
          onChange={(e) => setGlobalFilter(e.target.value)}
          placeholder="Buscar"
        />
      </span>
    </div>
  );

  const exportExcelAceptados = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(aceptados);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(
        excelBuffer,
        "Aceptados-Bancos- " + cuentaSeleccionada.nombre,
      );
    });
  };

  const exportExcelRechazados = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(rechazados);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(
        excelBuffer,
        "Rechazados-Bancos- " + cuentaSeleccionada.nombre,
      );
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      return new Promise((resolve) => {
        saveAs(
          data,
          fileName + "-" + new Date().toLocaleDateString() + EXCEL_EXTENSION,
        );
        resolve(true);
      });
    });
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Proceso de Impresión",
      "No tiene permiso para acceder a esta pantalla !.",
      "error",
    );
    exitClick();
    return;
  };

  const cuentasFiltradas = cuentas.filter((c) => {
    if (banco === "credicoop") {
      return c.nombre?.toUpperCase().includes("CREDICOOP");
    }

    if (banco === "supervielle") {
      return c.nombre?.toUpperCase().includes("SUPERVIELLE");
    }

    return true;
  });
  //console.log(cuentas);
  //console.log(pendientes)

  return (
    <Fragment>
      <Menu />
      <Toast ref={toast} />
      {statusAcceso === 0 ? <Spinner /> : null}
      {statusAcceso === 400 ? accesoDenegado() : null}
      {statusAcceso === 200 ? (
        <Fragment>
          <Grid container spacing={2} style={{ padding: "1rem" }}>
            <Grid item xs={12}>
              <h2>Identificación de Créditos Bancarios</h2>
            </Grid>

            <Grid item xs={12} md={6}>
              <input
                ref={inputFileRef}
                type="file"
                accept=".xls,.xlsx"
                style={{ display: "none" }}
                onChange={(e) => {
                  if (e.target.files && e.target.files.length > 0) {
                    setArchivo(e.target.files[0]);
                  }
                }}
              />

              <ButtonMui
                variant="contained"
                startIcon={<UploadFileIcon />}
                onClick={() => inputFileRef.current.click()}
                fullWidth
              >
                Seleccionar Excel
              </ButtonMui>
            </Grid>

            <Grid item xs={12} md={6}>
              <ButtonMui
                variant="contained"
                color="primary"
                onClick={leerArchivo}
                fullWidth
                disabled={
                  procesando ||
                  !cuentaSeleccionada ||
                  cuentaSeleccionada.length === 0 ||
                  !fechaDesde ||
                  !fechaHasta
                }
              >
                Leer créditos
              </ButtonMui>
            </Grid>

            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                flexWrap: "wrap",
              }}
            >
              <div>
                {archivo && (
                  <>
                    <b>Archivo:</b> {archivo.name}
                  </>
                )}
              </div>

              <Dropdown
                value={cuentaSeleccionada}
                options={cuentasFiltradas}
                onChange={(e) => setCuentaSeleccionada(e.value)}
                placeholder="Seleccione Cuenta"
                optionLabel="nombre"
                showClear
                style={{ width: "250px" }}
              />

              <TextField
                label="Desde"
                type="date"
                value={fechaDesde}
                onChange={(e) => setFechaDesde(e.target.value)}
                InputLabelProps={{ shrink: true }}
                size="small"
                style={{ width: "170px" }}
              />

              <TextField
                label="Hasta"
                type="date"
                value={fechaHasta}
                onChange={(e) => setFechaHasta(e.target.value)}
                InputLabelProps={{ shrink: true }}
                size="small"
                style={{ width: "170px" }}
              />
            </Grid>

            <Grid item xs={12}>
              <ButtonMui
                variant="contained"
                color="success"
                startIcon={<SearchIcon />}
                onClick={identificarSocios}
                disabled={procesando || movimientos.length === 0}
              >
                Identificar socios en base de datos
              </ButtonMui>

              <ButtonMui
                variant="contained"
                disabled={
                  procesando || (identificados && identificados.length === 0)
                }
                color="warning"
                startIcon={<SyncIcon />}
                onClick={procesarSocios}
                style={{ marginLeft: "2em" }}
              >
                Procesar Registros Identificados
              </ButtonMui>

              {procesando && progresoIdentificacion > 0 && (
                <Grid item xs={12}>
                  <ProgressBar value={progresoIdentificacion} />
                </Grid>
              )}

              <button
                id="listadoBancos"
                type="button"
                onClick={(e) => {
                  exportExcelAceptados();
                  exportExcelRechazados();
                }}
                style={{ display: "none" }}
              >
                Export Excel
              </button>

              <ButtonMui
                variant="outlined"
                color="secondary"
                icon="pi pi-arrow-left"
                onClick={exitClick}
                style={{ marginLeft: "2em" }}
              >
                Volver
              </ButtonMui>
            </Grid>

            <Grid item xs={12}>
              <DataTable
                value={movimientos}
                paginator
                rows={50}
                rowsPerPageOptions={[20, 50, 100]}
                globalFilter={globalFilter}
                header={header}
                responsiveLayout="scroll"
                emptyMessage="No hay movimientos cargados"
              >
                <Column field="fecha" header="Fecha" sortable />
                <Column field="concepto" header="Concepto" sortable />
                <Column
                  field="credito"
                  header="Crédito"
                  body={importeBody}
                  sortable
                />
                <Column field="cuit" header="CUIT" sortable />
                <Column field="cbu" header="CBU" sortable />
                <Column
                  field="nombreExtraido"
                  header="Nombre extraído"
                  sortable
                />
                <Column header="Socio encontrado" body={socioBody} sortable />
                <Column field="score" header="Score" sortable />
                <Column header="Estado" body={estadoBody} sortable />
              </DataTable>
            </Grid>
          </Grid>
        </Fragment>
      ) : null}
    </Fragment>
  );
}
